import { useState, useCallback, useEffect, useRef } from 'react'
import req from '@sportninja/common/api/request'
import type { SchedulerRequest } from './useSchedulerRequest'

export interface SchedulerFlight {
  id: string
  flight_number: number
  label: string | null
  display_label: string
  start_date: string | null
  end_date: string | null
  status: string // 'draft' | 'published'
  status_label: string
  is_default: boolean
  sort_order: number
  active_request: SchedulerRequest | null
  published_at: string | null
  created_at: string
  updated_at: string
}

export function useSchedulerFlights(scheduleId?: string) {
  const [flights, setFlights] = useState<SchedulerFlight[]>([])
  const [loading, setLoading] = useState(false)
  const hasLoadedRef = useRef(false)

  const fetchFlights = useCallback(async () => {
    if (!scheduleId) {
      return
    }
    if (!hasLoadedRef.current) {
      setLoading(true)
    }
    try {
      const { data } = await req(`/scheduler/schedules/${scheduleId}/flights`)
      const items = data?.data ?? data
      setFlights(Array.isArray(items) ? items : [])
      hasLoadedRef.current = true
    } catch {
      setFlights([])
    } finally {
      setLoading(false)
    }
  }, [scheduleId])

  useEffect(() => {
    fetchFlights()
  }, [fetchFlights])

  return { flights, loading, refetch: fetchFlights }
}
